import styled from '@emotion/styled';

export const DarkCalendar = styled.div`
  .react-calendar {
    background-color: var(--colorBlack);
  }

  button.react-calendar__navigation__label {
    color: var(--colorBlueGray50);
  }

  .react-calendar__tile {
    color: var(--colorBlueGray50);
  }

  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus,
  .react-calendar__tile--active {
    color: var(--colorBlack);
  }

  .react-calendar__tile--active:enabled:hover::before,
  .react-calendar__tile--active:enabled:focus::before,
  .react-calendar__tile--active::before {
    background-color: var(--colorBlueGray50);
  }

  .react-calendar__month-view__weekdays__weekday {
    color: var(--colorBlueGray200);
  }

  .react-calendar__navigation button[disabled] {
    color: var(--colorBlueGray50);
  }

  .react-calendar__navigation button {
    color: var(--colorBlueGray50);
  }
`;
